export default __webpack_public_path__ + "static/media/Telly-Filler-graphic.0dac6d56.gif";